export default __webpack_public_path__ + "static/media/Earnings Call Transcript.3d95983c.pdf";